export function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d as any);
}

export const apiDateFormat = "yyyy-MM-dd";
